import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import BipolarHorizontal from './BipolarHorizontal';
import BipolarVertical from './BipolarVertical';
import SliderBipolar from './SliderBipolar';
import { QUESTION_MATRIX_BIPOLAR_STYLES } from './constants';
import useOnMount from './hooks/useOnMount';
import useSetup from './hooks/useSetup';
import { onScrollDownMessage, toggleQuestionCollapse } from './utils';

export default function MatrixBipolar({ question, rtl }) {
  const { rows, matrixStyle, labels, minWidth, minAnswerWidth } = useSetup({
    question,
  });
  // Set the selected column of each row we will use it
  // when we validate the input or send it to server.
  // There can be only one selected column per row.
  const onClickColumn = useCallback(
    (event) => {
      event.preventDefault();
      const target = $(event.target);
      target.siblings().removeClass('column-selected');
      target.addClass('column-selected');
      const parentAnswerEl = $(target).parents('.answer--bipolar');
      parentAnswerEl.addClass('answerClick');
      const columnId = parseInt(target.attr('data-column-id'), 10);
      const columnOrder = parseInt(target.attr('data-column-order'), 10);
      parentAnswerEl.attr('data-selected-column-id', columnId);
      parentAnswerEl.attr('data-selected-column-order', columnOrder);

      // If style is vertical then columns should hide
      if (matrixStyle === QUESTION_MATRIX_BIPOLAR_STYLES.VERTICAL) {
        const answersContainer = target.closest('.bipolar-vertical-wrapper');
        toggleQuestionCollapse(answersContainer);
      }
      const questionWrapper = Pollfish.ui.getClosestQuestionWrapperElement(
        target,
      );
      const isDisplaySamePage = Pollfish.ui.isQuestionDisplaySamePage(
        questionWrapper,
      );
      if (!isDisplaySamePage) {
        onScrollDownMessage();
      }
      Pollfish.ui.validateQuestionAnswers(questionWrapper);
    },
    [matrixStyle],
  );
  useOnMount({
    questionRefId: question.refId,
    rows,
    matrixStyle,
    rtl,
    onClickColumn,
  });

  switch (matrixStyle) {
    case QUESTION_MATRIX_BIPOLAR_STYLES.HORIZONTAL:
      return (
        <BipolarHorizontal
          rows={rows}
          labels={labels}
          minWidth={minWidth}
          minAnswerWidth={minAnswerWidth}
        />
      );
    case QUESTION_MATRIX_BIPOLAR_STYLES.VERTICAL:
      return <BipolarVertical rows={rows} labels={labels} />;
    case QUESTION_MATRIX_BIPOLAR_STYLES.SLIDER:
      return (
        <SliderBipolar
          rows={rows}
          labels={labels}
          minAnswerWidth={minAnswerWidth}
        />
      );
    default:
      return (
        <BipolarHorizontal
          rows={rows}
          labels={labels}
          minWidth={minWidth}
          minAnswerWidth={minAnswerWidth}
        />
      );
  }
}

MatrixBipolar.propTypes = {
  question: PropTypes.object,
  rtl: PropTypes.bool,
};
